<template>
  <div id="NowCreating">
    <section>
      <div id="container">
        <h1 class="title has-text-centered">作成中です。</h1>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "NowCreating",
  methods: {
    back: function(){
      this.$router.go(-1);
    },
  },
  data() {
    return {
    };
  },
  filters: {},
  components: {},
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/NowCreating.vue